import appConfig from "appConfig";

export const PUBLISHABLE_KEY = appConfig.stripe.publishable_key;
